export const LANDING = '/';
export const HOME = '/home';
export const ACCOUNT = '/account';
export const ADMIN = '/admin';
export const PASSWORD_FORGET = '/reset-password';
export const NEW_ENROLLMENTS = '/enrollments';
export const COURSES = '/courses';
export const MY_ENROLLMENTS = '/my-enrollments';
export const MY_FLAGS = '/my-flags';
export const PARENT_FEEDBACK = '/parent-feedback';
export const KNOWLEDGE_BASE_ASSISTANT = '/knowledge-base-assistant';
export const SESSIONS = '/sessions';
export const MENTOR_ACTIVITY_REPORT = '/activity-report';
export const PAST_STUDENTS = '/past-students';

export const VIDEO_MEETING = '/video-meeting';
export const STUDENT_PROFILE = '/student-profile';

export const SESSION_DETAILS = '/session-details';

export const MANAGE_USERS_V3 = '/admin/manage-users-v3';
export const MANAGE_MENTORS_V3 = '/admin/mentors-v3';
export const MANAGE_STUDENTS = '/admin/students';
export const MANAGE_PARENTS_SURVEY = '/admin/parents-survey';
export const PARENT_SESSION_FEEDBACK = '/admin/parent-session-feedback';
export const MANAGE_COURSES = '/admin/manage-courses';
export const MEETING_MANAGEMENT = '/admin/meeting-management';
export const NPS_DASHBOARD = '/admin/nps-dashboard';
export const ACTIVITY_REPORT = '/admin/activity-report';
export const REPORTING = '/admin/reporting';
export const EXTRA_SERVICES = '/admin/extra-services';
export const CONTRACTS = '/admin/contracts';
export const ADMISSION_RESULTS = '/admin/admission-results';
export const EMAIL_LOG = '/admin/email-log';
export const SYSTEM_HEALTH = '/admin/system-health';
export const AT_RISK_STUDENTS = '/admin/at-risk-students';
export const MEETING_ISSUES = '/admin/meeting-issues';
export const AUDIT_LOG = '/admin/audit-log';
export const USER_JOURNEY = '/admin/user-journey';
export const MENTOR_PERFORMANCE = '/admin/mentor-performance';
export const COURSE_PLAN_GENERATOR = '/admin/course-plan-generator';
export const COURSE_PLANS = '/admin/course-plans';
export const CASE_TRACKER = '/admin/case-tracker';
export const STRATEGISTS = '/admin/strategists';
export const HUBSPOT_ONBOARDING = '/admin/hubspot-onboarding';
export const FLAGS = '/admin/flags';
export const PROFILES = '/admin/profiles';
export const ENROLLMENTS = '/admin/enrollments';
export const MAJORS = '/admin/majors';
export const EXAMS = '/admin/exams';
export const MANAGE_KNOWLEDGE = '/admin/manage-knowledge-base';
export const KNOWLEDGE_BASE = '/admin/knowledge-base';
export const UNIVERSITIES = '/admin/universities';
export const K12 = '/admin/k12-schools';

export const MENTOR_HOME = '/mentor/home';
export const MENTOR_STUDENTS = '/mentor/students';
export const MENTOR_MEETINGS = '/mentor/meetings';
export const MENTOR_SETTINGS = '/mentor/settings';
export const MENTOR_PAYMENTS = '/mentor/payments';
export const MENTOR_REQUESTS_INBOX = '/mentor/requests';

export const PRIVACY_POLICY = '/privacy-policy';
